import React, { useEffect } from 'react';
import { ScheduleOrientationOnboarding as View } from '@views';
import { trackEvent } from '@utils/mixpanel';
import { useLocation } from 'react-router-dom';

const ScheduleOrientationOnboarding = () => {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = 'Mindspace: Schedule Orientation';
    document.title = pageTitle;

    window.gtag('event', 'page_view', {
      page_title: pageTitle,
    });

    trackEvent('Page Viewed', {
      Page: 'Schedule Orientation - Onboarding',
    });
  }, []);

  return <View direction={location?.state?.direction} />;
};

export default ScheduleOrientationOnboarding;
